(function ($) {
    const initializeCaseStudyCarouselBlock = function ($block) {
        $block.find('.case-study-carousel-content').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $block.find('.case-study-carousel-slider #prev-slide'),
            nextArrow: $block.find('.case-study-carousel-slider #next-slide'),
            dots: false,
            fade: false,
            cssEase: 'ease',
            speed: 600,
            autoplay: false,
            pauseOnHover: true,
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        variableWidth: false
                    }
                }
            ]
        });
    }

    $(document).ready(function () {
        $('.wp-block-cite-theme-case-study-carousel').each(function () {
            const $block = $(this);
            initializeCaseStudyCarouselBlock($block);
        });
    });

})(jQuery);
